import React, { useEffect, useRef } from 'react';

function formatCep(value) {
  // Remove tudo que não for número
  const onlyNums = value.replace(/\D/g, '').slice(0, 8);
  if (onlyNums.length <= 5) return onlyNums;
  return onlyNums.slice(0, 5) + '-' + onlyNums.slice(5);
}

const inputStyle = {
  width: '100%',
  maxWidth: '100%',
  minWidth: '0',
  height: '40px',
  padding: '8px 12px',
  margin: 0,
  borderRadius: '4px',
  border: '1px solid #ccc',
  background: '#fff',
  boxSizing: 'border-box',
  display: 'block',
  transition: 'none',
  outline: 'none',
  boxShadow: 'none',
  fontSize: '1rem',
  textAlign: 'left',
  fontFamily: 'inherit',
  fontWeight: 400,
};

export default function InputCepCustom({ value, onChange, disabled, onCepDataFetch, ...props }) {
  const lastCepRef = useRef('');

  useEffect(() => {
    const rawCep = (value || '').replace(/\D/g, '');
    if (rawCep.length === 8 && rawCep !== lastCepRef.current) {
      lastCepRef.current = rawCep;
      fetch(`https://viacep.com.br/ws/${rawCep}/json/`)
        .then(res => res.json())
        .then(data => {
          if (onCepDataFetch) onCepDataFetch(data);
        });
    }
  }, [value, onCepDataFetch]);

  return (
    <input
      type="text"
      placeholder="00000-000"
      value={formatCep(value || '')}
      onChange={e => {
        const raw = e.target.value.replace(/\D/g, '').slice(0, 8);
        onChange && onChange(raw);
      }}
      maxLength={9}
      disabled={disabled}
      style={inputStyle}
      {...props}
    />
  );
} 